<ul>
  <li class="w1">
    <div>
      <span>"</span>
      <strong>I’m too young for menopause</strong>
    </div>
    <div>
      <p>The perimenopause can begin up to 15 years before periods actually stop. This means that, while it’s not common, some women experience symptoms in their late twenties and thirties.</p>
    </div>
  </li>
  <li class="w2">
    <div>
      <span>"</span>
      <strong>I’m afraid of getting old</strong>
    </div>
    <div>
      <p>Menopause and perimenopause are natural life stages and we experience them at different times. Understanding them and getting help with them actually helps you feel youthful for longer.</p>
    </div>
  </li>
  <li class="w3">
    <div>
      <span>"</span>
      <strong>I’m afraid of hormone therapy</strong>
    </div>
    <div>
      <p>Hormone Replacement Therapy, otherwise known as HRT, got a bad reputation in its earliest form. It’s safe to say, the science has progressed significantly since then. Our experts will talk you through the detail and help you decide what’s best for you.</p>
    </div>
  </li>
</ul>

<style>
  ul {
    display: flex;
    flex-direction: column;
    padding: 0;
    margin: 0;
    list-style: none;
  }

  li {
    display: flex;
    margin: 1rem 0;
    padding: 2rem;
    border-radius: 4rem;
    border: 1px solid rgba(0,0,0,.08);
    box-shadow: 0 .5rem 2rem rgba(0,0,0,.08);
    overflow: hidden;
    background-color: var(--bg-1);
    background-repeat: no-repeat;
    background-size: 50% auto;
    background-position: -50% 50%;
  }

  .w1 { background-image: url("../images/w1.svg"); }
  .w2 { background-image: url("../images/w2.svg"); }
  .w3 { background-image: url("../images/w3.svg"); }

  div {
    flex: 1 1 50%;
    display: flex;
    flex-direction: column;
    padding: 2rem;
    position: relative;
  }

  span {
    position: absolute;
    top: 0;
    left: 0;
    font-family: var(--ff-2);
    font-size: 12rem;
    line-height: 1;
    opacity: .25;
  }

  strong {
    font-family: var(--ff-2);
    font-weight: normal;
    font-size: 2.25rem;
    max-width: 11ch;
    margin-left: auto;
  }
  
  p {
    margin: 0 0 1rem
  }

  @media (max-width: 52rem) {
    li {
      flex-direction: column;
      background-size: 75% auto;
      background-position: -75% 25%;
    }
    span {
      left: -1rem;
      font-size: 8rem;
    }
    strong {
      max-width: unset;
      margin-left: 0;
      margin-bottom: -2rem;
    }
  }
</style>